module.exports = __webpack_public_path__ + "img/SzakacsBotond- Co-Founder.a1042368.jpg";